import '@babel/polyfill'
import 'mutationobserver-shim'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import Vuelidate from 'vuelidate'
import { BootstrapVue, IconsPlugin, ToastPlugin, LayoutPlugin } from 'bootstrap-vue'
import VueClickOutsideElement from 'vue-click-outside-element'
import vSelect from 'vue-select'
import VuePhoneNumberInput from 'vue-phone-number-input'
import PortalVue from 'portal-vue'
import { Kalendar } from 'kalendar-vue'
import VueMask from 'v-mask'
import Vue2OrgTree from 'vue2-org-tree'
import Multiselect from 'vue-multiselect'
import VueIntercom from 'vue-intercom'

import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  globalOptions: { currency: 'USD' }
}
Vue.use(VueCurrencyInput, pluginOptions)

Vue.use(VueIntercom, { appId: 'x2ckeuvy' })

Vue.component('multiselect', Multiselect)
Vue.use(Vue2OrgTree)
Vue.use(VueMask)
Vue.use(Kalendar)
Vue.use(PortalVue)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.component('v-select', vSelect)
Vue.use(VueClickOutsideElement)
Vue.use(Vuelidate)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(LayoutPlugin)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)

Vue.config.productionTip = false
export const bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js